import axios from 'axios';
import {
	Message
} from 'element-ui';
import {encrypt,decrypt} from '../components/common/common';

// let base = 'http://192.168.0.122:8888/';
//let base = 'http://192.168.2.105:8888/';
let base = "https://ins.xinchacha.com/";

axios.interceptors.request.use(config => {
	return config;
}, err => {
	Message.error({
		message: '请求超时!'
	});
	// return Promise.resolve(err);
});

axios.interceptors.response.use(data => {    // 请求失败校验
	if (data.status && data.status == 200 && data.data.status == 10086) {
    }
	return data;
}, err => {
	if (err.response.status == 504 || err.response.status == 404) {
		Message.error({
			message: '服务器被吃了⊙﹏⊙∥'
		});
	} else if (err.response.status == 403) {
		Message.error({
			message: '权限不足,请联系管理员!'
		});
	} else if (err.response.status == 401) {
		Message.error({
			message: err.response.data.msg
		});
	}else {
		if (err.response.data.msg) {
			Message.error({
				message: err.response.data.msg
			});
		} else {
			Message.error({
				message: '未知错误!'
			});
		}
	}
	// return Promise.resolve(err);
});

export const getDateRequest = (url , sanshu)=>{
    return axios.get(base+url,{
		params:sanshu,
		headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
	});
};

var getWindowUrl = function(){
	return window.location.href;
};

export const postRequest = (url , params)=>{
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var time = new Date().getTime();
	var headObj = {
		'token': token,
		'username':userId,
		'time':time,
		'Content-Type': 'application/json;charset=UTF-8',
		'baseUrl':getWindowUrl()
	};
	var headObj1 = {
		'Content-Type': 'application/json;charset=UTF-8',
		'time':time,
		'baseUrl':getWindowUrl()
	};
    return axios({
		method: 'post',
		url: `${base}${url}`,
		data: params,
		headers: userId != null? headObj:headObj1
	});
};

var getTimeString = function(){
	var timeString = new Date().getTime();
	return timeString;
};

export const getRequest = (url, params) => {
	// ${base}
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj=null;
	var headObj1=null;
	if(url.indexOf('search/findCompanyBasicInfoById?id=')>0){
		var timeString = getTimeString();
		var aa = url.split('?id=')[1];
		aa = encrypt(aa,timeString);
		var bb = encrypt(url.split('?id=')[1],getTimeString());
		var ourl = url.split('?id=')[0] + '?id=' +bb;
		headObj = {
			'token': token,
			'username':userId,
			'Content-Type': 'application/x-www-form-urlencoded',
			'time':timeString,
			'params':aa
		}
		headObj1 = {
			'Content-Type': 'application/x-www-form-urlencoded',
			'time': timeString,
			'params':aa
		}
		return axios({
			method: 'get',
			url: `${base}${ourl}`,
			params:params,
			headers: userId != null? headObj:headObj1
		});
	}else if(url.indexOf('search/findCompanyBasicInfo?id=')>0){
		var timeString = getTimeString();
		var aa = url.split('?id=')[1];
		aa = encrypt(aa,timeString);
		var bb = encrypt(url.split('?id=')[1],getTimeString());
		var ourl = url.split('?id=')[0] + '?id=' +bb;
		headObj = {
			'token': token,
			'username':userId,
			'Content-Type': 'application/x-www-form-urlencoded',
			'time':timeString,
			'params':aa
		}
		headObj1 = {
			'Content-Type': 'application/x-www-form-urlencoded',
			'time': timeString,
			'params':aa
		}
		return axios({
			method: 'get',
			url: `${base}${ourl}`,
			params:params,
			headers: userId != null? headObj:headObj1
		});
	}else if(url.indexOf('search/getFontUrl')>0){
		var timeString = getTimeString();
		var aa = url.split('?id=')[1];
		aa = encrypt(aa,timeString);
		var bb = encrypt(url.split('?id=')[1],getTimeString());
		var ourl = url.split('?id=')[0] + '?id=' +bb;
		headObj = {
			'token': token,
			'username':userId,
			'Content-Type': 'application/x-www-form-urlencoded',
			'time':timeString,
			'params':aa
		}
		headObj1 = {
			'Content-Type': 'application/x-www-form-urlencoded',
			'time': timeString,
			'params':aa
		}
		return axios({
			method: 'get',
			url: `${base}${ourl}`,
			params:params,
			headers: userId != null? headObj:headObj1
		});
	}else{
		headObj = {
			'token': token,
			'username':userId,
			'Content-Type': 'application/x-www-form-urlencoded'
		}
		headObj1 = {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
		return axios({
			method: 'get',
			url: `${base}${url}`,
			params:params,
			headers: userId != null? headObj:headObj1
		});
	}


};


export const postParamDun = (url, sanshu) => {
	// ${base}
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj = {
		'token': token,
		'username':userId,
		'Content-Type': 'application/x-www-form-urlencoded',
		'access-control-allow-origin':"*",
		'baseUrl':getWindowUrl()
	}
	var headObj1 = {
		'Content-Type': 'application/x-www-form-urlencoded',
		'access-control-allow-origin':"*",
		'baseUrl':getWindowUrl()
	}
	return axios({
		method: 'post',
		url: `${base}${url}`,
		data:sanshu,
		transformRequest: [function(data) {
			let ret = '';
			for (let it in data) {
				ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
			};
			return ret;
		}],
		headers: userId != null ? headObj:headObj1
	});
};


export const postfromRequest = (url, params) => {
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj = {
	  'token': token,
	  'username': userId,
	  'Content-Type': 'application/x-www-form-urlencoded',
	  'baseUrl':getWindowUrl()
	}
	var headObj1 = {
	  'Content-Type': 'application/x-www-form-urlencoded',
	  'baseUrl':getWindowUrl()
	}
	// ${base}
	return axios({
	  method: 'post',
	  url: `${base}${url}`,
	  data: params,
	  transformRequest: [function (data) {
		let ret = ''
		for (let it in data) {
		  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
		}
		return ret
	  }],
	  headers: userId != null ? headObj : headObj1
	});
};



// WEBPACK FOOTER //
// ./src/utils/api.js